/* Father's Day LP — countdown + persona pulse. Deferred, no dependencies. */
(function () {
  'use strict';

  /* ── Countdown ── */
  function initCountdown() {
    var el = document.getElementById('countdown');
    if (!el) return;
    var deadlineStr = el.getAttribute('data-deadline') || '2026-06-17T23:59:00-06:00';
    var cutoff = new Date(deadlineStr).getTime();
    var timer;

    function tick() {
      var diff = cutoff - new Date().getTime();
      if (isNaN(cutoff)) { el.textContent = ''; return; }
      if (diff <= 0) {
        el.textContent = el.getAttribute('data-passed') || 'CUTOFF PASSED';
        if (timer) clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
    }

    if (isNaN(cutoff)) { el.textContent = ''; return; }
    tick();
    if (cutoff - new Date().getTime() > 0) {
      timer = setInterval(tick, 1000);
    }
  }

  /* ── Persona → kit smooth-scroll already handled by CSS scroll-behavior;
        add a brief highlight pulse on the targeted kit card. ── */
  function initPersonaPulse() {
    document.querySelectorAll('a.dad-card[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function () {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        target.classList.remove('fd-pulse');
        void target.offsetWidth;            /* restart the animation */
        target.classList.add('fd-pulse');
      });
    });
  }

  function init() { initCountdown(); initPersonaPulse(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
